export default __webpack_public_path__ + "static/media/empty_tabPesanan.aff05ca2.svg";